import { render, staticRenderFns } from "./QrcodeComponentForm.vue?vue&type=template&id=72574112&scoped=true&"
import script from "./QrcodeComponentForm.vue?vue&type=script&lang=ts&"
export * from "./QrcodeComponentForm.vue?vue&type=script&lang=ts&"
import style0 from "./QrcodeComponentForm.vue?vue&type=style&index=0&id=72574112&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72574112",
  null
  
)

export default component.exports